import React, { createContext, useContext, useMemo } from 'react';

import { ROLES } from '../../../../_configuration';
import { getActiveAssessment } from '../../../lib/services/assessment.service';

interface ICommunicationPanelContext {
  // The assessment the panel is scoped to: the global active if COMMUNICATION-
  // eligible, else the newest eligible. Read-only — never writes user.settings.
  panelAssessmentId: string | undefined;
  // Its display name, from the same cached assessments read — no extra query.
  panelAssessmentName: string | undefined;
}

const CommunicationPanelContext = createContext<ICommunicationPanelContext | undefined>(undefined);

interface ICommunicationPanelProviderProps {
  children: React.ReactNode;
}

export const CommunicationPanelProvider: React.FC<ICommunicationPanelProviderProps> = ({
  children
}) => {
  const { assessment } = getActiveAssessment({ requiredRoles: [ROLES.COMMUNICATION] });

  const value = useMemo<ICommunicationPanelContext>(() => ({
    panelAssessmentId: assessment && assessment._id,
    panelAssessmentName: assessment && assessment.name
  }), [assessment]);

  return (
    <CommunicationPanelContext.Provider value={value}>
      {children}
    </CommunicationPanelContext.Provider>
  );
};

export const useCommunicationPanelContext = (): ICommunicationPanelContext => {
  const ctx = useContext(CommunicationPanelContext);
  if (!ctx) {
    throw new Error('useCommunicationPanelContext must be used inside a CommunicationPanelProvider');
  }
  return ctx;
};
